<template>
    <b-row class="slide-body">
        <b-col cols="2">
            <router-link :to="{name:'slide29',params:{lang:lang}}"><b-img id="img-left" src="@/images/button-left.png" :title="$t('general.previous')" fluid></b-img></router-link>
        </b-col>

        <b-col cols="4">
            <b-row align-h="center" class="pb-3 pt-5">   
                <h1 style="color:#ffff00"><strong>{{ $t('slide30.text1') }}</strong></h1>
            </b-row>
            <b-row align-h="center">   
                <h3 style="color:#ffffff"><strong>{{ $t('slide30.text2') }}</strong></h3>
            </b-row>
            <b-row align-h="center" class="pt-5">   
                <b-card><h2><strong>{{puntsTotals}}</strong></h2></b-card>
            </b-row>
            
            
        </b-col>
        <b-col cols="4">
            <div class="contenedor">                
                <b-img align="bottom" src="@/images/slide30-bubble-1.png" fluid></b-img>
                <div class="texto-centrado"><p><strong>{{ $t('slide30.text3') }}</strong></p></div>
            </div>
            <img src="@/images/slide30-tronic.png"/>
        </b-col>
        <b-col cols="2">
            <router-link :to="{name:'slide31',params:{lang:lang}}"><b-img id="img-right" src="@/images/button-right.png" :title="$t('general.next')" fluid></b-img></router-link> 
        </b-col>
    </b-row> 
</template>


<script>
import {mapState} from 'vuex';

export default { 
    props:['lang'],
    data(){
        return {                
            modalRegisterPuntuationShow: false,     
        }
    },    
    computed: {
        ...mapState(['showMenu','puntsTotals','slide0Escola','slide0Equip','slide0Curs','solOptima','PuntsJoc1','elapsedTimeGame1','PuntsJoc2',
        'elapsedTimeGame2']),
    },
    methods:{
        
    },
    beforeCreate(){
        this.$store.dispatch('changeShowMenu',false);
    },
    created(){
        this.$i18n.locale=this.lang;
        var optima = "0";
        if(this.solOptima){
            optima="1";
        }

        this.$http.post('https://notescapisdelaindustria.cat/admin/processData.php', {
                "puntstotals": this.puntsTotals,
                "lang": this.lang,
                "escola": this.slide0Escola,
                "equip": this.slide0Equip,
                "curs": this.slide0Curs,
                "soloptima": optima,
                "puntsjoc1": this.PuntsJoc1,
                "tempsjoc1": this.elapsedTimeGame1,
                "puntsjoc2": this.PuntsJoc2,
                "tempsjoc2": this.elapsedTimeGame2
            }).then(
            response => {
                console.log(response.data);
            }
        );
    } 
}
</script>


<style scoped>

    .row{
        margin-left: 0px;
        margin-right: 0px;  
        position:relative; 
        width: 100%; 
    }    

    .contenedor{
        position: relative;
        display: inline-block;
        text-align: center;
    }
    
    .texto-centrado{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -60%);
    } 

</style>
